<main class="text-2xl">

  <div class="flex justify-center">
    <app-general-heading [header1]="'Termos de Uso e Políticas de Privacidade'"
    ></app-general-heading>
  </div>


  <section class="max-w-screen-xl pb-16 mx-auto sm:px-6 text-black text-sm ">


    <div class="text-gray-500 w-10/12 text-justify lg:w-2/3 space-y-4 mx-auto">

      <p class="pb-10">A sua privacidade e a boa utilização da plataforma AngolaEncontra são muito importantes para nós.
        Ao acessar ou
        utilizar a plataforma, você concorda com os Termos de Uso e as Políticas de Privacidade descritas abaixo.
        Pedimos que leia com atenção.</p>

      <h1 class="font-bold tracking-wide text-gray-700  text-3xl p4-8">Termos de Uso</h1>
      <div>
        <h1 class="font-bold tracking-wide text-gray-700  text-xl p4-8 my-4">Compromisso do Usuário</h1>
        <p class="mb-2">Ao utilizar a plataforma AngolaEncontra, o usuário compromete-se a:</p>
        <ol class="space-y-2">
          <li>1. Não se envolver em atividades ilegais ou contrárias à boa fé e à ordem pública.</li>
          <li>2. Não difundir propaganda ou conteúdo de natureza discriminatória, ofensiva, pornográfica ou ilegal,
            incluindo, mas não se limitando, a conteúdo racista, xenofóbico, apologia ao terrorismo ou violação dos
            direitos humanos.
          </li>
          <li>3. Não causar danos aos sistemas físicos (hardware) e lógicos (software) do AngolaEncontra, seus
            fornecedores ou terceiros, incluindo a introdução ou disseminação de vírus ou outros sistemas maliciosos.
          </li>
          <li>4. Usar a plataforma exclusivamente para os fins a que se propõe: relatar ocorrências de perdidos e
            achados
            de maneira ética e responsável.
          </li>
        </ol>
      </div>

      <div>
        <h1 class="font-bold tracking-wide text-gray-700  text-xl p4-8 my-6">Boas Práticas da Comunidade</h1>
        <p class="mb-2">O uso da plataforma AngolaEncontra está sujeito às seguintes diretrizes de conduta:</p>
        <ol class="space-y-2">
          <li>1. <u>Veracidade das Informações:</u> Ao postar uma ocorrência, você se compromete a fornecer informações
            corretas
            e verdadeiras. A inclusão de informações falsas ou enganosas resultará na exclusão do conteúdo e possível
            suspensão da conta.
          </li>
          <li>2. <u>Uso Adequado da Plataforma:</u> Utilize a AngolaEncontra exclusivamente para reportar itens perdidos
            ou encontrados. Não é permitido o uso da plataforma para fins comerciais, spam ou conteúdo irrelevante.
          </li>
          <li>3. <u>Respeito à Privacidade:</u> Qualquer informação pessoal compartilhada na plataforma, como números de
            telefone ou e-mails, deve ser fornecida de forma consciente e voluntária. Respeitamos a privacidade dos
            usuários e incentivamos o mesmo entre a comunidade.
          </li>
          <li>4. <u>Responsabilidade:</u> O AngolaEncontra não se responsabiliza pela autenticidade das ocorrências
            postadas pelos usuários. A plataforma atua apenas como um intermediário entre as partes.
          </li>
          <li>5. <u>Moderação de Conteúdo:</u> A equipe de moderação do AngolaEncontra se reserva o direito de remover
            postagens que violem as políticas da plataforma, incluindo conteúdo ofensivo, impróprio ou não relacionado à
            finalidade do sistema.
          </li>
          <li>6. <u>Seja Claro e Específico:</u> Ao relatar um item perdido ou encontrado, forneça o máximo de detalhes
            possível, incluindo descrições precisas, fotos claras e informações relevantes sobre a localização e
            circunstâncias.
          </li>
          <li>7. <u>Comunique-se Respeitosamente:</u> Use a plataforma para ajudar outras pessoas de forma respeitosa e
            construtiva. Evite discussões ou conflitos com outros usuários.
          </li>
          <li>8. <u>Atualize as Informações:</u> Caso você tenha encontrado ou recuperado um item, lembre-se de
            atualizar ou remover sua postagem para manter as informações na plataforma sempre precisas.
          </li>
          <li>9. <u>Cuidado com Informações Pessoais:</u> Evite compartilhar informações sensíveis ou privadas
            publicamente na plataforma. Sempre que possível, utilize os meios de contato privado fornecidos para
            discutir detalhes.
          </li>
          <li>10. <u>Verifique as Informações:</u> Antes de postar, verifique se os dados que você está compartilhando
            são corretos. Isso ajuda a evitar confusão e a aumentar as chances de sucesso.
          </li>

          <li>11. <u>Consequências do Não Cumprimento:</u> O descumprimento de qualquer uma dessas políticas poderá
            resultar em advertências, suspensão ou exclusão da conta.
          </li>
        </ol>
      </div>

      <div>
        <h1 class="font-bold tracking-wide text-gray-700  text-xl p4-8 my-6">Remoção de Ocorrências</h1>
        <ol class="space-y-2">
          <li>1. Ocorrências serão mantidas na plataforma até que sejam resolvidas ou removidas pelo criador.</li>
          <li>2. Usuários podem remover a qualquer momento os itens criados por eles mesmos.</li>
          <li>3. Caso um usuário deseje a remoção de um item que não foi criado por ele, poderá utilizar o canal de
            denúncia para que os moderadores analisem a solicitação e decidam pela remoção, se pertinente.
          </li>
        </ol>
      </div>

      <div class="py-5">
        <hr>
      </div>
      <h1 class="font-bold tracking-wide text-gray-700  text-3xl p4-8">Política de Privacidade</h1>
      <p>A sua privacidade é importante para nós. Esta política descreve como coletamos, usamos e protegemos suas
        informações pessoais.</p>

      <div>
        <h1 class="font-bold tracking-wide text-gray-700  text-xl p4-8 my-6">Coleta de Dados</h1>
        <ol class="space-y-2">
          <li>1. Solicitamos informações pessoais apenas quando realmente precisamos delas para fornecer um serviço.
          </li>
          <li>2. Coletamos dados de maneira justa e legal, com o seu conhecimento e consentimento. Informamos por que
            estamos coletando os dados e como serão usados.
          </li>
        </ol>
      </div>

      <div>
        <h1 class="font-bold tracking-wide text-gray-700  text-xl p4-8 my-6">Retenção e Finalidade dos Dados</h1>
        <ol class="space-y-2">
          <li>1. Os dados sensíveis serão removidos assim que cumprirem o seu propósito (ex.: item encontrado).</li>
          <li>2. Os dados poderão ser removidos a qualquer momento mediante solicitação do usuário.</li>
          <li>3. Apenas retemos as informações coletadas pelo tempo necessário para fornecer o serviço solicitado,
            protegendo-as contra perdas, roubos e acessos não autorizados.
          </li>
        </ol>
      </div>

      <div>
        <h1 class="font-bold tracking-wide text-gray-700  text-xl p4-8 my-6"> Compartilhamento de Dados</h1>
        <ol class="space-y-2">
          <li>1. Não compartilhamos informações de identificação pessoal publicamente ou com terceiros, exceto quando
            exigido por lei.
          </li>
          <li>2. Os dados permanecem exclusivamente em nossa base de dados e não são transferidos ou manipulados para
            outros fins.
          </li>
        </ol>
      </div>

      <div>
        <h1 class="font-bold tracking-wide text-gray-700  text-xl p4-8 my-6">Cookies</h1>
        <p>Utilizamos cookies para melhorar sua experiência no site. Estes arquivos permitem o funcionamento adequado de
          certas funcionalidades, como login, preferências de usuário e análise de uso do site. Você pode desativar os
          cookies em seu navegador, mas isso pode impactar negativamente a funcionalidade da plataforma.
        </p>
        <h1 class="font-bold tracking-wide text-gray-700  text-md p4-8 mt-4 mb-1">Cookies de Terceiros</h1>
        <p>Usamos serviços como o Google Analytics para entender como você utiliza o site e como podemos melhorá-lo.
          Estes cookies rastreiam informações como tempo de uso e páginas visitadas.</p>

        <h1 class="font-bold tracking-wide text-gray-700  text-md p4-8 mt-4 mb-1">Links Externos</h1>
        <p>Nosso site pode conter links para sites externos que não são operados por nós. Não temos controle sobre o
          conteúdo e práticas desses sites e não assumimos responsabilidade por suas políticas de privacidade.</p>

        <h1 class="font-bold tracking-wide text-gray-700  text-md p4-8 mt-4 mb-1">Segurança dos Dados</h1>
        <p>Implementamos medidas adequadas para proteger os dados coletados, incluindo criptografia, controles de acesso
          e backups regulares. Tomamos todas as precauções razoáveis para evitar acessos não autorizados.</p>
      </div>

      <div class="py-5">
        <hr>
      </div>

      <div>
        <h1 class="font-bold tracking-wide text-gray-700  text-3xl p4-8 my-6">Direitos do Usuário</h1>
        <ol class="space-y-2">
          <li>1. Você pode recusar a coleta de dados pessoais, entendendo que isso pode limitar sua experiência em nossa
            plataforma.
          </li>
          <li>2. O uso continuado do site será considerado como aceitação das nossas práticas em torno de privacidade e
            informações pessoais.
          </li>
          <li></li>
        </ol>
      </div>

      <div class="py-5">
        <hr>
      </div>
      <h1 class="font-bold tracking-wide text-gray-700  text-3xl p4-8">Proteção de Dados</h1>
      <div class="space-y-2">
        <p>As imagens enviadas pelos usuários são avaliadas por uma equipe de moderadores antes da publicação. Dados
          sensíveis poderão ser ofuscados ou removidos, caso necessário, para garantir a privacidade e a segurança de
          todas as partes envolvidas.</p>

        <p>A plataforma AngolaEncontra compromete-se a armazenar os dados dos usuários apenas pelo tempo necessário para
          cumprir a finalidade pela qual foram coletados. Os dados relacionados a pessoas desaparecidas, documentos
          encontrados ou veículos roubados serão armazenados enquanto houver uma tentativa de resolver a ocorrência
          (ex.: pessoa encontrada, documento devolvido, veículo recuperado). Quando uma ocorrência for resolvida, os
          dados serão eliminados ou anonimizados dentro de um prazo máximo de 30 dias.</p>

        <p>A plataforma também oferece ao usuário a possibilidade de solicitar a remoção de suas publicações a qualquer
          momento, dentro dos limites legais aplicáveis. Os usuários também podem remover diretamente os itens criados
          por eles mesmos. Caso desejem solicitar a remoção de um item que não foi criado por eles, podem utilizar o
          canal de denúncia disponível. Após análise, os moderadores decidirão pela remoção, caso seja pertinente.</p>
      </div>

      <p class="pt-10">Esta política é efetiva a partir de Janeiro de 2025.</p>
    </div>
  </section>
</main>
